import * as React from 'react';

import config from 'js/app/config';
import { FormattedHTMLMessage, FormattedMessage } from 'js/lib/coursera.react-intl';
import path from 'js/lib/path';

import { DecorativeImage } from '@coursera/coursera-ui';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/NoActiveCoursesMessage';

const STUDY_ICON_SRC = path.join(config.url.assets, 'images/degree-home/study_icon.svg');

class NoActiveCoursesMessage extends React.Component {
  render() {
    return (
      <div className="rc-NoActiveCoursesMessage vertical-box align-items-absolute-center p-a-3">
        <DecorativeImage className="study-icon" src={STUDY_ICON_SRC} height={142} width={142} />

        <div className="headline-2-text align-horizontal-center">
          <FormattedMessage message={_t('No activity during this week')} />
        </div>
        <div className="body-1-text align-horizontal-center p-b-1">
          <FormattedHTMLMessage message={_t("You'll be able to see and track your progress here.")} />
        </div>
      </div>
    );
  }
}

export default NoActiveCoursesMessage;
